// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-02T10:37:54Z                      #

// ##############################################################

import {utils} from "mc/lib";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.pop.controller.RegistraceController.
 */
export default class RegistraceApi {
    /**
     * 
     *
     * @param subjekt 
     * @return 
     */
    static newRegistration(subjekt : SubjektVO) : Promise<RegistraceVysledekVO> {
        const uri = serverContextPath + `/api/registrace`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateSubjektVO_C902A1(subjekt), headers));
    }

    /**
     * 
     *
     * @return 
     */
    static getRegistrationText() : Promise<string> {
        const uri = serverContextPath + `/api/registrace/text`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return 
     */
    static getReCaptchaSiteKey() : Promise<string> {
        const uri = serverContextPath + `/api/registrace/recaptcha/site-key`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}